export const TP_TOS = "https://www.inkle.io/tp-payments-terms-service";
